import React from "react";
import { SEO } from "@/components/SEO";
import { RevealText, Reveal } from "@/components/brand/Reveal";
import { BrandButton } from "@/components/brand/BrandButton";
import { SITE_NAME } from "@/content/siteConfig";

export default function NotFound() {
  return (
    <>
      <SEO title={`Page not found - ${SITE_NAME}`} description="This page could not be found." path="/404" noindex />

      <section className="mx-auto flex min-h-[60vh] max-w-3xl flex-col items-center justify-center px-6 py-20 text-center">
        <span className="font-serif text-6xl text-periwinkle">404</span>
        <RevealText
          lines={["Page not found."]}
          className="mt-4 font-heading text-3xl sm:text-4xl"
          lineClassName="mx-auto"
          as="h1"
        />
        <Reveal delay={0.3}>
          <p className="mt-4 max-w-md text-base text-cvbody">
            The page you are looking for moved, or never existed. Let's get you back.
          </p>
          <div className="mt-8">
            <BrandButton to="/" data-testid="notfound-home-link">
              Back to home
            </BrandButton>
          </div>
        </Reveal>
      </section>
    </>
  );
}
